<template>
  <div class="form-text">
    <ion-item>
      <ion-input
        :inputmode="inputmode"
        :type="type"
        :value="computedValue"
        @input="handleInput"
        @keyup.enter="onEnter"
      />
    </ion-item>
  </div>
</template>

<script>
export default {
  name: "FormText",
  props: {
    value: String,
    properties: Object
  },
  computed: {
    inputmode() {
      return this.properties.inputmode || "text";
    },
    uppercase() {
      return this.properties.uppercase;
    },
    type() {
      return this.properties.number ? "number" : "text";
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    onEnter(e) {
      const target = e.target;
      if (target && typeof target.blur === "function") {
        target.blur();
      }
      this.$emit("next");
    },
    handleInput(e) {
      let value = e.target.value;
      if (this.uppercase) {
        value = String(value).toUpperCase();
      }
      this.computedValue = value;
    }
  }
};
</script>
